"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[127],{

/***/ 28868:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ sendEmail; }
/* harmony export */ });
/* harmony import */ var _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

function sendEmail(name, subject, message, file) {
    return _sendEmail.apply(this, arguments);
}
function _sendEmail() {
    _sendEmail = _asyncToGenerator(_home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(name, subject, message, file) {
        var data;
        return _home_ubuntu_rekstrarvorur_storefront_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = new FormData();
                    data.append("name", name);
                    data.append("subject", subject);
                    data.append("message", message);
                    if (file) {
                        data.append("file", file);
                    }
                    return _ctx.abrupt("return", fetch("/api/sendgrid", {
                        body: data,
                        method: "POST"
                    }));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _sendEmail.apply(this, arguments);
}


/***/ }),

/***/ 72997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomSlider; }
/* harmony export */ });
/* unused harmony export MiniSlider */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46066);
/* harmony import */ var react_slider__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(58466);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54572);
/* harmony import */ var styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(186);
/* harmony import */ var styled_tools__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41145);
/* harmony import */ var src_themes__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52287);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31494);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n\n  .slick-list {\n    overflow: visible !important;\n    backface-visibility: hidden;\n    perspective: 2000px;\n  }\n\n  /* Fix for adaptive height in react-slick */\n  .slick-slide {\n    height: auto;\n\n    & > div {\n      height: 100%;\n      & > div {\n        height: 100%;\n      }\n    }\n  }\n  .slick-track {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: stretch;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  padding-right: 16px;\n\n  &:focus {\n    outline: none !important;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n\n    &.hideOnSm {\n      display: none;\n    }\n\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n    &.hideOnMd {\n      display: none;\n    }\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n    &.hideOnLg {\n      display: none;\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n    &.hideOnXl {\n      display: none;\n    }\n  "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  align-items: center;\n  margin-bottom: 24px;\n  margin-right: 16px;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n    display: flex;\n\n    &.hideOnSm {\n      visibility: hidden;\n    }\n\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    &.hideOnMd {\n      visibility: hidden;\n    }\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _taggedTemplateLiteral([
        "\n    &.hideOnLg {\n      visibility: hidden;\n    }\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _taggedTemplateLiteral([
        "\n    &.hideOnXl {\n      visibility: hidden;\n    }\n  "
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: center;\n  padding-top: 20px;\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _taggedTemplateLiteral([
        "\n  width: 80%;\n  max-width: 420px;\n  height: 16px;\n  cursor: pointer;\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _taggedTemplateLiteral([
        "\n  top: 7px;\n  bottom: 7px;\n  background: ",
        ";\n  border-radius: 0;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _taggedTemplateLiteral([
        "\n  height: 6px;\n  width: ",
        "%;\n  margin: 5px 0;\n  border: 0;\n  border-radius: 0;\n  background-color: ",
        ";\n  cursor: grab;\n\n  span {\n    display: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &.darkMode {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _taggedTemplateLiteral([
        "\n    overflow: hidden;\n    padding-top: 10px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _taggedTemplateLiteral([
        "\n  &:hover {\n    ~ ",
        " {\n      ",
        " {\n        z-index: -1;\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}











var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject());
var SlideWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject1());
var SliderHeader = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject2());
var TitleContentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject3());
var SliderBtnsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject8(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.sm(_templateObject4()), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.md(_templateObject5()), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.lg(_templateObject6()), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.desktop(_templateObject7()));
var MiniSliderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject13(), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.sm(_templateObject9()), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.md(_templateObject10()), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.lg(_templateObject11()), styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.desktop(_templateObject12()));
var MiniSlider = (0,styled_components__WEBPACK_IMPORTED_MODULE_9__["default"])(react_slider__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_templateObject14());
var MiniSliderTrack = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject15(), (0,styled_tools__WEBPACK_IMPORTED_MODULE_6__/* .palette */ .DG)("black20"));
var MiniSliderThumb = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject16(), function(p) {
    return 100 / (p.totalSlideSteps || 1);
}, (0,styled_tools__WEBPACK_IMPORTED_MODULE_6__/* .palette */ .DG)("red"), (0,styled_tools__WEBPACK_IMPORTED_MODULE_6__/* .palette */ .DG)("white"));
var HiddenDots = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject17());
var SliderWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div(_templateObject19(), MiniSliderWrapper, MiniSlider, styled_bootstrap_grid__WEBPACK_IMPORTED_MODULE_5__.media.md(_templateObject18()));
var firstClientX;
var clientX;
var preventTouch = function(e) {
    var minValue = 5 // threshold
    ;
    clientX = e.touches[0].clientX - firstClientX;
    // Vertical scrolling does not work when you start swiping horizontally.
    if (Math.abs(clientX) > minValue) {
        e.preventDefault();
        return false;
    }
    return true;
};
var touchStart = function(e) {
    firstClientX = e.touches[0].clientX;
};
function CustomSlider(param) {
    var title = param.title, children = param.children, sm = param.sm, md = param.md, lg = param.lg, xl = param.xl;
    var ref6, ref1, ref2;
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), currSlide = ref3[0], setCurrSlide = ref3[1];
    var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((0,lodash__WEBPACK_IMPORTED_MODULE_3__.size)(children)), totalSlideSteps = ref4[0], setTotalSlideSteps = ref4[1];
    var dotsRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var childrenCount = react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children);
    var hideOnXl = childrenCount <= xl;
    var hideOnLg = childrenCount <= lg;
    var hideOnMd = childrenCount <= md;
    var hideOnSm = childrenCount <= sm;
    var ref5;
    var onReInitSlider = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        var ref;
        return setTotalSlideSteps((ref5 = (ref = dotsRef.current) === null || ref === void 0 ? void 0 : ref.childElementCount) !== null && ref5 !== void 0 ? ref5 : 0);
    }, [
        dotsRef,
        setTotalSlideSteps
    ]);
    var changeSlide = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(_, index) {
        return setCurrSlide((0,lodash__WEBPACK_IMPORTED_MODULE_3__.ceil)(index));
    }, [
        setCurrSlide
    ]);
    var onClickPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (currSlide > 0) {
            var ref;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickPrev();
            setCurrSlide(currSlide - 1);
        }
    }, [
        currSlide,
        sliderRef,
        setCurrSlide
    ]);
    var onClickNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (currSlide < totalSlideSteps - 1) {
            var ref;
            sliderRef === null || sliderRef === void 0 ? void 0 : (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickNext();
            setCurrSlide(currSlide + 1);
        }
    }, [
        totalSlideSteps,
        currSlide,
        sliderRef,
        setCurrSlide
    ]);
    var onChangeMiniSlider = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(index, _) {
        var ref;
        if (Array.isArray(index)) {
            return;
        }
        (ref = sliderRef.current) === null || ref === void 0 ? void 0 : ref.slickGoTo(index);
        setCurrSlide(index);
    }, [
        sliderRef,
        setCurrSlide
    ]);
    var settings = {
        infinite: false,
        arrows: false,
        speed: 400,
        slidesToShow: xl,
        slidesToScroll: 1,
        waitForAnimate: false,
        swipeToSlide: true,
        dots: true,
        appendDots: function(dots) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HiddenDots, {
                ref: dotsRef,
                children: dots
            });
        },
        beforeChange: changeSlide,
        onReInit: onReInitSlider,
        useTransform: false,
        touchThreshold: 100,
        responsive: [
            {
                breakpoint: src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme */ .k === null || src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme */ .k === void 0 ? void 0 : (ref6 = src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme.breakpoints */ .k.breakpoints) === null || ref6 === void 0 ? void 0 : ref6.lg,
                settings: {
                    slidesToShow: lg
                }
            },
            {
                breakpoint: src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme */ .k === null || src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme */ .k === void 0 ? void 0 : (ref1 = src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme.breakpoints */ .k.breakpoints) === null || ref1 === void 0 ? void 0 : ref1.md,
                settings: {
                    slidesToShow: md
                }
            },
            {
                breakpoint: src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme */ .k === null || src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme */ .k === void 0 ? void 0 : (ref2 = src_themes__WEBPACK_IMPORTED_MODULE_7__/* .gridTheme.breakpoints */ .k.breakpoints) === null || ref2 === void 0 ? void 0 : ref2.sm,
                settings: {
                    speed: 200,
                    slidesToShow: sm
                }
            }, 
        ]
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var currentRef = containerRef.current;
        if (currentRef) {
            currentRef.addEventListener("touchstart", touchStart);
            currentRef.addEventListener("touchmove", preventTouch, {
                passive: false
            });
        }
        return function() {
            if (currentRef) {
                currentRef.removeEventListener("touchstart", touchStart);
                currentRef.removeEventListener("touchmove", preventTouch, {
                    passive: false
                });
            }
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
        className: "slider-wrapper",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SliderHeader, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TitleContentWrapper, {
                        className: "slider-title",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(SliderBtnsWrapper, {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                            hideOnXl: hideOnXl,
                            hideOnLg: hideOnLg,
                            hideOnMd: hideOnMd,
                            hideOnSm: hideOnSm
                        }),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_8__/* .ArrowButton */ .b4, {
                                direction: "left",
                                onClick: onClickPrev,
                                outlined: true
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_8__/* .ArrowButton */ .b4, {
                                direction: "right",
                                onClick: onClickNext,
                                outlined: true,
                                style: {
                                    marginLeft: "16px"
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliderWrapper, {
                ref: containerRef,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread({
                    ref: sliderRef
                }, settings, {
                    children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, function(child, index) {
                        return(// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SlideWrapper, {
                            children: child
                        }, typeof child === "object" && child != null && "key" in child ? child.key : index));
                    })
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniSliderWrapper, {
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()({
                    hideOnXl: hideOnXl,
                    hideOnLg: hideOnLg,
                    hideOnMd: hideOnMd,
                    hideOnSm: hideOnSm
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniSlider, {
                    min: 0,
                    max: totalSlideSteps - 1,
                    value: currSlide,
                    renderTrack: function(props) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniSliderTrack, _objectSpread({}, props));
                    },
                    renderThumb: function(props) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniSliderThumb, _objectSpread({}, props, {
                            totalSlideSteps: totalSlideSteps
                        }));
                    },
                    onChange: onChangeMiniSlider
                })
            })
        ]
    });
};


/***/ }),

/***/ 32437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P": function() { return /* binding */ DatocmsContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/api/saleor/generated/index.tsx
var generated = __webpack_require__(49554);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(186);
// EXTERNAL MODULE: ./src/utils/paths.ts
var paths = __webpack_require__(27827);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightLineIcon.js
var ArrowRightLineIcon = __webpack_require__(94187);
var ArrowRightLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightLineIcon);
// EXTERNAL MODULE: ./src/themes/index.tsx
var themes = __webpack_require__(52287);
// EXTERNAL MODULE: ./src/context/PageContext.tsx
var PageContext = __webpack_require__(11764);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/styles/scrollStyle.ts
var scrollStyle = __webpack_require__(58728);
// EXTERNAL MODULE: ./src/components/typography/index.tsx + 1 modules
var typography = __webpack_require__(56795);
// EXTERNAL MODULE: ./src/components/common/index.tsx + 15 modules
var common = __webpack_require__(69446);
// EXTERNAL MODULE: ./node_modules/styled-bootstrap-grid/dist/index.js
var dist = __webpack_require__(54572);
// EXTERNAL MODULE: ./src/components/common/DatoStructuredText.tsx + 9 modules
var DatoStructuredText = __webpack_require__(68248);
// EXTERNAL MODULE: ./src/components/layout/index.ts + 8 modules
var layout = __webpack_require__(49012);
;// CONCATENATED MODULE: ./src/components/pageBlocks/TextBlock.tsx
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 800px;\n  margin: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable @typescript-eslint/no-explicit-any */ /* Incorrect typing for this one datocms guy */ 




var Wrapper = styled_components_browser_esm["default"].div(_templateObject());
function TextBlock(param) {
    var text = param.text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DatoStructuredText/* default */.Z, {
                    content: text
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./src/components/pageBlocks/ImageBlock.tsx
function ImageBlock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ImageBlock_templateObject() {
    var data = ImageBlock_taggedTemplateLiteral([
        "\n  position: relative;\n  max-width: 100%;\n  height: 20vh;\n"
    ]);
    ImageBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var Container = (0,styled_components_browser_esm["default"])(dist.Container)(ImageBlock_templateObject());
function ImageBlock(param) {
    var image = param.image;
    var ref;
    if (!(image === null || image === void 0 ? void 0 : (ref = image.responsiveImage) === null || ref === void 0 ? void 0 : ref.src)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                layout: "fill",
                src: image === null || image === void 0 ? void 0 : image.responsiveImage.webpSrcSet
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/common/Video.tsx
var Video = __webpack_require__(12956);
;// CONCATENATED MODULE: ./src/components/pageBlocks/VideoBlock.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function VideoBlock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function VideoBlock_templateObject() {
    var data = VideoBlock_taggedTemplateLiteral([
        "\n  max-width: 800px;\n  margin: auto;\n"
    ]);
    VideoBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}






var VideoWrapper = styled_components_browser_esm["default"].div(VideoBlock_templateObject());
function VideoBlock(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, _objectSpread({}, props))
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/MailFillIcon.js
var MailFillIcon = __webpack_require__(81315);
var MailFillIcon_default = /*#__PURE__*/__webpack_require__.n(MailFillIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/PhoneFillIcon.js
var PhoneFillIcon = __webpack_require__(60911);
var PhoneFillIcon_default = /*#__PURE__*/__webpack_require__.n(PhoneFillIcon);
// EXTERNAL MODULE: ./node_modules/styled-tools/dist/es/index.js + 6 modules
var es = __webpack_require__(41145);
;// CONCATENATED MODULE: ./src/components/pageBlocks/EmployeeList.tsx
function EmployeeList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function EmployeeList_templateObject() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n  padding-bottom: 24px;\n  height: 100%;\n"
    ]);
    EmployeeList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n    min-height: 200px;\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n  display: flex;\n  border: 1px solid ",
        ";\n  min-height: 140px;\n  height: 100%;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n    min-width: 160px;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n  background-repeat: no-repeat;\n  background-position: top-center;\n  background-image: url('",
        "');\n  min-width: 120px;\n\n  ",
        "\n\n  @media only screen and (max-width:600px) {\n    background-size: cover;\n    background-position: top-center;\n    width: 120px;\n    height: 100%;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n\n  svg {\n    margin-right: 10px;\n  }\n\n  a {\n    transition: color 0.25s;\n    &:hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n    padding: 24px;\n\n    &:before {\n      top: 16px;\n    }\n\n    ",
        " {\n      margin-bottom: 8px;\n    }\n    ",
        " {\n      margin-bottom: 8px;\n    }\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n  padding: 16px;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 10px;\n    width: 20px;\n    border-top: 1px solid ",
        ";\n  }\n\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = EmployeeList_taggedTemplateLiteral([
        ""
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = EmployeeList_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  border-top: 1px solid ",
        ";\n  font-style: italic;\n  padding-top: 16px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}











var EmployeeWrapper = styled_components_browser_esm["default"].div(EmployeeList_templateObject());
var Employee = styled_components_browser_esm["default"].div(_templateObject2(), (0,es/* palette */.DG)("black20"), dist.media.md(_templateObject1()));
var EmployeeImage = styled_components_browser_esm["default"].div(_templateObject4(), (0,es/* prop */.vg)("backgroundImg"), dist.media.md(_templateObject3()));
var Line = styled_components_browser_esm["default"].div(_templateObject5(), (0,es/* palette */.DG)("red"));
var EmployeeInfo = styled_components_browser_esm["default"].div(_templateObject7(), (0,es/* palette */.DG)("red"), dist.media.sm(_templateObject6(), typography/* Title7 */.Mz, typography.P));
var EmployeeListWrapper = styled_components_browser_esm["default"].div(_templateObject8());
var Comment = styled_components_browser_esm["default"].div(_templateObject9(), (0,es/* palette */.DG)("black20"));
function EmployeeList(param1) {
    var title = param1.title, employees = param1.employees;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title5 */.IV, {
                    withGutter: true,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeListWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                        children: employees === null || employees === void 0 ? void 0 : employees.map(function(param) {
                            var id = param.id, name = param.name, email = param.email, role = param.role, mobilePhone = param.mobilePhone, officePhone = param.officePhone, comment = param.comment, image = param.image;
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Col, {
                                sm: 6,
                                md: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Employee, {
                                        children: [
                                            (image === null || image === void 0 ? void 0 : image.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(EmployeeImage, {
                                                backgroundImg: image === null || image === void 0 ? void 0 : image.url
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* NoImage */.Dy, {
                                                size: 40,
                                                text: "Mynd v\xe6ntanleg",
                                                textSize: "14"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EmployeeInfo, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                                        children: name
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                                                        children: role
                                                    }),
                                                    !!email && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((MailFillIcon_default()), {
                                                                size: 16,
                                                                color: themes/* theme.palette.red */.r.palette.red
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                                                bold: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    href: "mailto:".concat(email),
                                                                    children: email
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    !!comment && /*#__PURE__*/ (0,jsx_runtime.jsx)(Comment, {
                                                        children: comment
                                                    }),
                                                    !comment && !!officePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((PhoneFillIcon_default()), {
                                                                size: 16,
                                                                color: themes/* theme.palette.red */.r.palette.red
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                                                bold: true,
                                                                children: officePhone
                                                            })
                                                        ]
                                                    }),
                                                    !comment && !!mobilePhone && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Line, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((PhoneFillIcon_default()), {
                                                                size: 16,
                                                                color: themes/* theme.palette.red */.r.palette.red
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                                                bold: true,
                                                                children: mobilePhone
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }, id);
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/styles/shadowStyles.ts
var shadowStyles = __webpack_require__(23633);
;// CONCATENATED MODULE: ./src/components/pageBlocks/TextImageBlock.tsx
function TextImageBlock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function TextImageBlock_templateObject() {
    var data = TextImageBlock_taggedTemplateLiteral([
        "\n      ",
        "\n    "
    ]);
    TextImageBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TextImageBlock_templateObject1() {
    var data = TextImageBlock_taggedTemplateLiteral([
        "\n  ",
        "\n  position: relative;\n  overflow: hidden;\n  display: grid;\n  height: 100%;\n  place-items: center;\n  img {\n    object-fit: contain !important;\n    position: absolute !important;\n    width: 40% !important;\n    height: auto !important;\n  }\n"
    ]);
    TextImageBlock_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TextImageBlock_templateObject2() {
    var data = TextImageBlock_taggedTemplateLiteral([
        "\n    padding-right: ",
        ";\n    padding-left: ",
        ";\n"
    ]);
    TextImageBlock_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TextImageBlock_templateObject3() {
    var data = TextImageBlock_taggedTemplateLiteral([
        "\n  padding-bottom: 24px;\n  max-width: 600px;\n\n  ",
        "\n"
    ]);
    TextImageBlock_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}









var ImageWrapper = styled_components_browser_esm["default"].div(TextImageBlock_templateObject1(), (0,es/* ifProp */.fq)({
    showBorder: true
}, (0,styled_components_browser_esm.css)(TextImageBlock_templateObject(), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: true,
    length: 8,
    showOnHover: false
}))));
var TextWrapper = styled_components_browser_esm["default"].div(TextImageBlock_templateObject3(), dist.media.sm(TextImageBlock_templateObject2(), (0,es/* ifProp */.fq)({
    mirrored: true
}, "0", "24px"), (0,es/* ifProp */.fq)({
    mirrored: true
}, "24px", "0")));
function TextImageBlock(param) {
    var title = param.title, text = param.text, image = param.image, mirrored = param.mirrored, showBorder = param.showBorder;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        sm: 6,
                        smOrder: mirrored ? 2 : 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextWrapper, {
                            mirrored: mirrored,
                            children: [
                                !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                                    title: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DatoStructuredText */._g, {
                                    content: text
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        sm: 6,
                        smOrder: mirrored ? 1 : 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageWrapper, {
                            showBorder: showBorder,
                            children: (image === null || image === void 0 ? void 0 : (ref = image.responsiveImage) === null || ref === void 0 ? void 0 : ref.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                src: image === null || image === void 0 ? void 0 : image.responsiveImage.src,
                                layout: "fill"
                            }) : null
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/IconBlock.tsx
function IconBlock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function IconBlock_templateObject() {
    var data = IconBlock_taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-evenly;\n  margin: 32px auto;\n"
    ]);
    IconBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function IconBlock_templateObject1() {
    var data = IconBlock_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 20px;\n  ",
        " {\n    margin-top: 20px;\n    width: inherit;\n    @media (max-width: ",
        ") {\n      font-size: 20px;\n    }\n  }\n"
    ]);
    IconBlock_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}







var IconContainer = (0,styled_components_browser_esm["default"])(dist.Container)(IconBlock_templateObject());
var IconSection = styled_components_browser_esm["default"].div(IconBlock_templateObject1(), typography.H4, themes/* theme.screenSize.sizeSM */.r.screenSize.sizeSM);
function IconBlock(param1) {
    var icons = param1.icons;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(IconContainer, {
        children: icons === null || icons === void 0 ? void 0 : icons.map(function(param) {
            var id = param.id, iconSlug = param.iconSlug, text = param.text;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconSection, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DynamicIcon */.pj, {
                        icon: iconSlug,
                        size: 50
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H4, {
                        children: text
                    })
                ]
            }, id);
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/ValueList.tsx
function ValueList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ValueList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ValueList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ValueList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ValueList_templateObject() {
    var data = ValueList_taggedTemplateLiteral([
        "\n  background-size: cover;\n  background-position: center;\n  background-image: url('",
        "');\n  height: 125px;\n  margin-bottom: 32px;\n  ",
        ";\n"
    ]);
    ValueList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ValueList_templateObject1() {
    var data = ValueList_taggedTemplateLiteral([
        "\n  border: 1px solid ",
        ";\n  padding: 32px;\n  height: 100%;\n"
    ]);
    ValueList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ValueList_templateObject2() {
    var data = ValueList_taggedTemplateLiteral([
        "\n  height: 100%;\n  padding-bottom: 24px;\n"
    ]);
    ValueList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var ValueImage = styled_components_browser_esm["default"].div(ValueList_templateObject(), (0,es/* prop */.vg)("backgroundImg"), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: true,
    length: 8,
    showOnHover: false
}));
var ValueCard = styled_components_browser_esm["default"].div(ValueList_templateObject1(), (0,es/* palette */.DG)("black10"));
var ValueWrapper = styled_components_browser_esm["default"].div(ValueList_templateObject2());
function Value(param) {
    var image = param.image, title = param.title, text = param.text;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ValueCard, {
            children: [
                (image === null || image === void 0 ? void 0 : (ref = image.responsiveImage) === null || ref === void 0 ? void 0 : ref.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ValueImage, {
                    backgroundImg: image === null || image === void 0 ? void 0 : image.responsiveImage.src
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H5, {
                    withGutter: true,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DatoStructuredText */._g, {
                    content: text
                })
            ]
        })
    });
}
function ValueList(param) {
    var title = param.title, small = param.small, values = param.values;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                    title: title !== null && title !== void 0 ? title : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: values === null || values === void 0 ? void 0 : values.map(function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            sm: 6,
                            md: small ? 3 : 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Value, ValueList_objectSpread({}, props))
                        }, props.id);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/BulletList.tsx
function BulletList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BulletList_templateObject() {
    var data = BulletList_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: flex-start;\n  padding: 16px 0;\n"
    ]);
    BulletList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BulletList_templateObject1() {
    var data = BulletList_taggedTemplateLiteral([
        "\n  padding-left: 24px;\n"
    ]);
    BulletList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var Bullet = styled_components_browser_esm["default"].div(BulletList_templateObject());
var BulletText = styled_components_browser_esm["default"].div(BulletList_templateObject1());
function BulletList(param1) {
    var title = param1.title, description = param1.description, bullets = param1.bullets;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        backgroundColor: themes/* theme.palette.background */.r.palette.background,
        customWidth: themes/* gridTheme.breakpoints.md */.k.breakpoints.md,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                    title: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.P, {
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: bullets === null || bullets === void 0 ? void 0 : bullets.map(function(param) {
                        var id = param.id, iconSlug = param.iconSlug, currentTitle = param.title, text = param.text;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            sm: 6,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Bullet, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DynamicIcon */.pj, {
                                        icon: iconSlug,
                                        size: 22
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BulletText, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                                                withGutter: true,
                                                children: currentTitle
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PSmall */.zK, {
                                                children: text
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, id);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowUpSLineIcon.js
var ArrowUpSLineIcon = __webpack_require__(92981);
var ArrowUpSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowUpSLineIcon);
// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowDownSLineIcon.js
var ArrowDownSLineIcon = __webpack_require__(10076);
var ArrowDownSLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowDownSLineIcon);
// EXTERNAL MODULE: ./src/utils/styles.ts
var styles = __webpack_require__(3795);
;// CONCATENATED MODULE: ./src/components/pageBlocks/AccordionList.tsx
function AccordionList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AccordionList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AccordionList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function AccordionList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function AccordionList_templateObject() {
    var data = AccordionList_taggedTemplateLiteral([
        "\n  padding-top: 16px;\n"
    ]);
    AccordionList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function AccordionList_templateObject1() {
    var data = AccordionList_taggedTemplateLiteral([
        "\n  padding: 10px;\n  cursor: pointer;\n"
    ]);
    AccordionList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function AccordionList_templateObject2() {
    var data = AccordionList_taggedTemplateLiteral([
        "\n  box-shadow: inset 0px -3px 0px #ef3f57, inset 0px 1px 0px #ef3f57;\n"
    ]);
    AccordionList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function AccordionList_templateObject3() {
    var data = AccordionList_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  ",
        ";\n  box-shadow: inset 0px -1px 0px #cecddc, inset 0px 1px 0px #cecddc;\n  transition: box-shadow 1s;\n\n  ",
        "\n"
    ]);
    AccordionList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function AccordionList_templateObject4() {
    var data = AccordionList_taggedTemplateLiteral([
        "\n  padding: 0 10px;\n\n  p {\n    font-size: 0.875rem;\n    color: ",
        ";\n  }\n"
    ]);
    AccordionList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function AccordionList_templateObject5() {
    var data = AccordionList_taggedTemplateLiteral([
        "\n  border: 0;\n  background-color: transparent;\n  border-radius: 0;\n  cursor: pointer;\n\n  &:hover {\n    .remixicon-icon {\n      fill: ",
        ";\n    }\n  }\n\n  &:focus {\n    outline: none;\n  }\n"
    ]);
    AccordionList_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function AccordionList_templateObject6() {
    var data = AccordionList_taggedTemplateLiteral([
        "\n  text-align: right;\n"
    ]);
    AccordionList_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}












var ListWrapper = styled_components_browser_esm["default"].div(AccordionList_templateObject());
var AccordionHead = styled_components_browser_esm["default"].div(AccordionList_templateObject1());
var expandedCSS = (0,styled_components_browser_esm.css)(AccordionList_templateObject2());
var Accordion = styled_components_browser_esm["default"].div(AccordionList_templateObject3(), (0,es/* palette */.DG)("white"), (0,styles/* fluidRange */.S)("margin-bottom", "8px", "16px"), function(props) {
    return props.isOpen && expandedCSS;
});
var StructuredTextWrapper = styled_components_browser_esm["default"].div(AccordionList_templateObject4(), (0,es/* palette */.DG)("black70"));
var OpenBtn = styled_components_browser_esm["default"].button(AccordionList_templateObject5(), (0,es/* palette */.DG)("red"));
var BtnWrapper = styled_components_browser_esm["default"].div(AccordionList_templateObject6());
function AccordionItem(param) {
    var title = param.title, content = param.content;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion, {
        isOpen: isOpen,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionHead, {
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            col: 10,
                            sm: 11,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title6 */.L8, {
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            col: 2,
                            sm: 1,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BtnWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenBtn, {
                                    isOpen: isOpen,
                                    children: isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowUpSLineIcon_default()), {
                                        size: 30,
                                        color: themes/* theme.palette.black */.r.palette.black
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowDownSLineIcon_default()), {
                                        size: 30,
                                        color: themes/* theme.palette.black */.r.palette.black
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Expandable */.Ak, {
                expanded: isOpen,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StructuredTextWrapper, {
                    children: content ? /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DatoStructuredText */._g, {
                        content: content
                    }) : null
                })
            })
        ]
    });
}
function AccordionList(param) {
    var title = param.title, description = param.description, accordions = param.accordions, _split = param.split, split = _split === void 0 ? false : _split;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                    title: title !== null && title !== void 0 ? title : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                    withGutter: true,
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                        children: accordions === null || accordions === void 0 ? void 0 : accordions.map(function(props) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 12,
                                md: split ? 6 : 12,
                                alignSelf: "start",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionItem, AccordionList_objectSpread({}, props))
                            }, props.id);
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/components/buttons/AnchorButton.tsx
var AnchorButton = __webpack_require__(49847);
;// CONCATENATED MODULE: ./src/components/pageBlocks/Banner.tsx
function Banner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function Banner_templateObject() {
    var data = Banner_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  ",
        "\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  min-height: 200px;\n\n  a {\n    display: block !important;\n    width: 100% !important;\n    height: 100% !important;\n    text-align: center;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    background-position: center !important;\n    ",
        "\n  }\n"
    ]);
    Banner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Banner_templateObject1() {
    var data = Banner_taggedTemplateLiteral([
        "\n  font-family: 'LetterboardLite';\n  font-style: normal;\n  font-weight: normal;\n  font-size: 80px;\n  line-height: 100px;\n  text-align: center;\n  color: ",
        ";\n\n  @media screen and (max-width: 768px) {\n    font-size: 20px;\n    line-height: 30px;\n    padding: 5px;\n  }\n"
    ]);
    Banner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Banner_templateObject2() {
    var data = Banner_taggedTemplateLiteral([
        "\n  font-family: 'LetterboardLite';\n  font-style: normal;\n  font-weight: normal;\n  font-size: 36px;\n  line-height: 48px;\n  text-align: center;\n  background-color: ",
        ";\n  color: ",
        ";\n  padding: 0 10px;\n  margin-bottom: 16px;\n\n  @media screen and (max-width: 768px) {\n    font-size: 20px;\n    line-height: 30px;\n    padding: 5px;\n  }\n"
    ]);
    Banner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Banner_templateObject3() {
    var data = Banner_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    Banner_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}







var BannerWrapper = styled_components_browser_esm["default"].div(Banner_templateObject(), function(param) {
    var backgroundImg = param.backgroundImg;
    return backgroundImg ? "background-image: url('".concat(backgroundImg, "');") : "";
}, function(param) {
    var heightMob = param.heightMob;
    return heightMob ? "min-height: ".concat(heightMob, "px") : "min-height: 150px;";
});
var BannerTitle = styled_components_browser_esm["default"].div(Banner_templateObject1(), (0,es/* palette */.DG)("white"));
var BannerDescription = styled_components_browser_esm["default"].div(Banner_templateObject2(), (0,es/* palette */.DG)("black"), (0,es/* palette */.DG)("white"));
var BannerInner = styled_components_browser_esm["default"].div(Banner_templateObject3());
function Banner(param) {
    var title = param.title, description = param.description, image = param.image, link = param.link, linkLabel = param.linkLabel, heightMob = param.heightMob;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                title && description && linkLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerWrapper, {
                    heightMob: heightMob,
                    backgroundImg: image === null || image === void 0 ? void 0 : (ref = image.responsiveImage) === null || ref === void 0 ? void 0 : ref.src,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerInner, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTitle, {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerDescription, {
                                children: description
                            }),
                            link && linkLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnchorButton/* default */.Z, {
                                color: "black",
                                outlined: true,
                                href: link,
                                withGutter: true,
                                children: linkLabel
                            })
                        ]
                    })
                }),
                !linkLabel && link && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: link,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerWrapper, {
                        heightMob: heightMob,
                        backgroundImg: image === null || image === void 0 ? void 0 : (ref1 = image.responsiveImage) === null || ref1 === void 0 ? void 0 : ref1.src,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerInner, {
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerTitle, {
                                    children: title
                                }),
                                description && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerDescription, {
                                    children: description
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/buttons/index.tsx + 6 modules
var buttons = __webpack_require__(31494);
;// CONCATENATED MODULE: ./src/components/pageBlocks/HeroBanner.tsx
function HeroBanner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function HeroBanner_templateObject() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n    height: calc(100vh - 162px);\n  "
    ]);
    HeroBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject1() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n          &:first-child {\n            height: 60%;\n          }\n          &:last-child {\n            height: 40%;\n          }\n        "
    ]);
    HeroBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject2() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n          &:first-child {\n            height: 100%;\n          }\n          &:last-child {\n            height: 100%;\n          }\n        "
    ]);
    HeroBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject3() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  position: relative;\n  height: calc(100vh - 106px);\n\n  ",
        "\n\n  ",
        " {\n    height: 100%;\n    ",
        " {\n      height: 100%;\n      ",
        " {\n        &:first-child {\n          height: 40%;\n        }\n        &:last-child {\n          height: 60%;\n        }\n\n        ",
        "\n\n        ",
        "\n      }\n    }\n  }\n"
    ]);
    HeroBanner_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject4() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    HeroBanner_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject5() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  ",
        ";\n"
    ]);
    HeroBanner_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject6() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n    position: absolute;\n    right: 0px;\n    left: 50%;\n    bottom: 0;\n    top: -128px;\n    background-position: center;\n    background-size: cover;\n\n    &:before {\n      content: '';\n      position: absolute;\n      right: 0px;\n      left: 0;\n      bottom: 0;\n      top: 0;\n      background-position: center;\n      background-size: cover;\n    }\n  "
    ]);
    HeroBanner_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject7() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  ",
        "\n\n  &:before {\n    ",
        "\n  }\n\n  ",
        "\n"
    ]);
    HeroBanner_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject8() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n    bottom: 40%;\n  "
    ]);
    HeroBanner_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function HeroBanner_templateObject9() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n    display: none;\n  "
    ]);
    HeroBanner_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  width: 100%;\n  position: absolute;\n  right: 0px;\n  left: 0%;\n  bottom: 60%;\n  top: -70px;\n  bottom: 60%;\n  background-position: center;\n  background-size: cover;\n  ",
        "\n\n  &:before {\n    content: '';\n    position: absolute;\n    right: 0px;\n    left: 0%;\n    bottom: 0;\n    top: 0;\n    ",
        "\n    background-position: center;\n    background-size: cover;\n  }\n\n  ",
        "\n\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  color: ",
        ";\n  text-transform: uppercase;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 17px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  height: 100%;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n    display: flex;\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = HeroBanner_taggedTemplateLiteral([
        "\n  display: none;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  bottom: 0;\n  left: calc(50% - 25px);\n  height: 50px;\n  width: 50px;\n  background-color: ",
        ";\n  opacity: 0;\n  transition: opacity 0.5s ease-in;\n\n  &.showArrow {\n    opacity: 50%;\n    cursor: pointer;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}












var HeroBanner_Wrapper = styled_components_browser_esm["default"].div(HeroBanner_templateObject3(), dist.media.md(HeroBanner_templateObject()), dist.Container, dist.Row, dist.Col, dist.media.sm(HeroBanner_templateObject1()), dist.media.md(HeroBanner_templateObject2()));
var TextSection = styled_components_browser_esm["default"].div(HeroBanner_templateObject4());
var TextContent = styled_components_browser_esm["default"].div(HeroBanner_templateObject5(), (0,styles/* fluidRange */.S)("padding-top", "24px", "100px"));
var DesktopImageSection = styled_components_browser_esm["default"].div(HeroBanner_templateObject7(), function(param) {
    var imgBackground = param.imgBackground;
    return imgBackground ? "background-image: url(".concat(imgBackground, ");") : "";
}, function(param) {
    var imgUrl = param.imgUrl;
    return imgUrl ? "background-image: url(".concat(imgUrl, ");") : "";
}, dist.media.md(HeroBanner_templateObject6()));
var MobileImageSection = styled_components_browser_esm["default"].div(_templateObject10(), function(param) {
    var imgBackground = param.imgBackground;
    return imgBackground ? "background-image: url(".concat(imgBackground, ");") : "";
}, function(param) {
    var imgUrl = param.imgUrl;
    return imgUrl ? "background-image: url(".concat(imgUrl, ");") : "";
}, dist.media.sm(HeroBanner_templateObject8()), dist.media.md(HeroBanner_templateObject9()));
var Label = styled_components_browser_esm["default"].div(_templateObject11(), (0,es/* palette */.DG)("red"));
var ImagePlaceholder = styled_components_browser_esm["default"].div(_templateObject12());
var ArrowWrapper = styled_components_browser_esm["default"].div(_templateObject14(), (0,es/* palette */.DG)("red"), dist.media.md(_templateObject13()));
function HeroBanner(param) {
    var title = param.title, description = param.description, label = param.label, buttonLink = param.buttonLink, buttonText = param.buttonText, image = param.image;
    var handleArrowClick = function handleArrowClick() {
        window.scroll({
            top: window.innerHeight - 155,
            behavior: "smooth"
        });
    };
    var ref, ref1, ref2, ref3;
    var ref4 = (0,react.useState)(false), showArrow = ref4[0], setShowArrow = ref4[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            setShowArrow(true);
        }, 3000);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeroBanner_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileImageSection, {
                imgUrl: image === null || image === void 0 ? void 0 : (ref = image.responsiveImage) === null || ref === void 0 ? void 0 : ref.src,
                imgBackground: image === null || image === void 0 ? void 0 : (ref1 = image.responsiveImage) === null || ref1 === void 0 ? void 0 : ref1.base64
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 12,
                                hiddenMdUp: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImagePlaceholder, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                                col: 12,
                                md: 6,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextSection, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TextContent, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Label, {
                                                children: label
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H1, {
                                                children: title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                                                withGutter: true,
                                                children: description
                                            }),
                                            buttonText && buttonLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* AnchorButton */.AN, {
                                                href: buttonLink,
                                                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {
                                                    color: themes/* theme.palette.red */.r.palette.red
                                                }),
                                                children: buttonText
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopImageSection, {
                        imgUrl: image === null || image === void 0 ? void 0 : (ref2 = image.responsiveImage) === null || ref2 === void 0 ? void 0 : ref2.src,
                        imgBackground: image === null || image === void 0 ? void 0 : (ref3 = image.responsiveImage) === null || ref3 === void 0 ? void 0 : ref3.base64
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowWrapper, {
                onClick: function() {
                    return handleArrowClick();
                },
                className: classnames_default()({
                    showArrow: showArrow
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowDownSLineIcon_default()), {
                    color: themes/* theme.palette.white */.r.palette.white,
                    size: 40
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/remixicon-react/ArrowRightUpLineIcon.js
var ArrowRightUpLineIcon = __webpack_require__(28698);
var ArrowRightUpLineIcon_default = /*#__PURE__*/__webpack_require__.n(ArrowRightUpLineIcon);
// EXTERNAL MODULE: ./src/components/common/Link.tsx
var Link = __webpack_require__(5695);
;// CONCATENATED MODULE: ./src/components/pageBlocks/SupplierList.tsx
function SupplierList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function SupplierList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            SupplierList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function SupplierList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function SupplierList_templateObject() {
    var data = SupplierList_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  height: 80px;\n"
    ]);
    SupplierList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SupplierList_templateObject1() {
    var data = SupplierList_taggedTemplateLiteral([
        "\n  position: relative;\n  padding-top: 16px;\n  margin-top: 16px;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0px;\n    right: 0px;\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    SupplierList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SupplierList_templateObject2() {
    var data = SupplierList_taggedTemplateLiteral([
        "\n  visibility: hidden;\n  position: absolute;\n  top: 0;\n  right: 0;\n"
    ]);
    SupplierList_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SupplierList_templateObject3() {
    var data = SupplierList_taggedTemplateLiteral([
        "\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  padding: 20px;\n  padding-bottom: 0;\n  height: 100%;\n  ",
        ";\n"
    ]);
    SupplierList_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SupplierList_templateObject4() {
    var data = SupplierList_taggedTemplateLiteral([
        "\n  height: 100%;\n  padding-bottom: 24px;\n\n  &:hover {\n    ",
        " {\n      border-color: ",
        ";\n    }\n\n    ",
        " {\n      visibility: visible;\n    }\n\n    ",
        " {\n      &:before {\n        border-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    SupplierList_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}












var Logo = styled_components_browser_esm["default"].div(SupplierList_templateObject());
var Content = styled_components_browser_esm["default"].div(SupplierList_templateObject1(), (0,es/* palette */.DG)("black20"));
var ArrowContainer = styled_components_browser_esm["default"].div(SupplierList_templateObject2());
var CardInner = styled_components_browser_esm["default"].div(SupplierList_templateObject3(), (0,es/* palette */.DG)("white"), (0,es/* palette */.DG)("black20"), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: false,
    length: 8,
    showOnHover: true
}));
var Card = styled_components_browser_esm["default"].div(SupplierList_templateObject4(), CardInner, (0,es/* palette */.DG)("red"), ArrowContainer, Content, (0,es/* palette */.DG)("red"));
function SupplierCard(param) {
    var logo = param.logo, text = param.text;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardInner, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightUpLineIcon_default()), {
                        color: themes/* theme.palette.red */.r.palette.red
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo, {
                    children: !!(logo === null || logo === void 0 ? void 0 : (ref = logo.responsiveImage) === null || ref === void 0 ? void 0 : ref.webpSrcSet) && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: logo.responsiveImage.webpSrcSet,
                        layout: "fill",
                        objectFit: "contain",
                        objectPosition: "center"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* DatoStructuredText */._g, {
                        content: text === null || text === void 0 ? void 0 : text.value
                    })
                })
            ]
        })
    });
}
function SupplierList(param) {
    var title = param.title, suppliers = param.suppliers;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                    title: title !== null && title !== void 0 ? title : ""
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: suppliers === null || suppliers === void 0 ? void 0 : suppliers.map(function(props) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            sm: 4,
                            md: 3,
                            lg: 2,
                            children: props.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: props.link,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplierCard, SupplierList_objectSpread({}, props))
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SupplierCard, SupplierList_objectSpread({}, props))
                        }, props.id);
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-mailchimp-form/dist/index.js
var react_mailchimp_form_dist = __webpack_require__(79175);
var react_mailchimp_form_dist_default = /*#__PURE__*/__webpack_require__.n(react_mailchimp_form_dist);
// EXTERNAL MODULE: ./src/components/form/Input.tsx
var Input = __webpack_require__(92469);
// EXTERNAL MODULE: ./src/components/buttons/buttonStyles.ts
var buttonStyles = __webpack_require__(58635);
;// CONCATENATED MODULE: ./src/components/pageBlocks/MailChimpForm.tsx
function MailChimpForm_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function MailChimpForm_templateObject() {
    var data = MailChimpForm_taggedTemplateLiteral([
        "\n  max-width: 700px;\n  margin: auto;\n  input {\n    ",
        "\n    margin-bottom: 16px;\n  }\n\n  button {\n    ",
        ";\n    ",
        ";\n    color: white;\n    justify-content: center;\n  }\n\n  .msg-alert {\n    text-align: center;\n    margin-top: 16px;\n  }\n"
    ]);
    MailChimpForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}









var FormWrapper = styled_components_browser_esm["default"].div(MailChimpForm_templateObject(), Input/* inputCommon */.oG, (0,buttonStyles/* buttonStyles */.$Y)({
    color: "secondary"
}), (0,buttonStyles/* buttonTextStyles */.ov)());
function MailChimpForm(param) {
    var title = param.title, description = param.description, formUrl = param.formUrl, inputs = param.inputs, submitLabel = param.submitLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormWrapper, {
                children: [
                    !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                        withGutter: true,
                        children: description
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((react_mailchimp_form_dist_default()), {
                        action: formUrl,
                        fields: inputs === null || inputs === void 0 ? void 0 : inputs.map(function(input) {
                            return {
                                name: input.name,
                                placeholder: input.label,
                                type: input.inputType,
                                required: input.required
                            };
                        }),
                        messages: {
                            sending: "Sendi...",
                            success: "Takk fyrir!",
                            error: "\xdaps! Eitthva\xf0 f\xf3r \xfarskei\xf0is.",
                            empty: "\xde\xfa ver\xf0ur a\xf0 sl\xe1 inn t\xf6lvup\xf3stfang",
                            duplicate: "T\xf6lvup\xf3stfang n\xfa \xfeegar skr\xe1\xf0",
                            button: submitLabel
                        }
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/CtaBlock.tsx
function CtaBlock_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CtaBlock_templateObject() {
    var data = CtaBlock_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  ",
        " {\n    width: inherit;\n  }\n"
    ]);
    CtaBlock_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var CtaWrapper = styled_components_browser_esm["default"].div(CtaBlock_templateObject(), typography.H1);
function CtaBlock(param) {
    var title = param.title, description = param.description, link = param.link, linkLabel = param.linkLabel;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CtaWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H1, {
                        withGutter: true,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                        withGutter: true,
                        children: description
                    }),
                    link && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnchorButton/* default */.Z, {
                        color: "red",
                        outlined: true,
                        href: link,
                        children: linkLabel
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/components/products/index.tsx + 38 modules
var components_products = __webpack_require__(18254);
// EXTERNAL MODULE: ./src/components/common/CustomSlider.tsx
var CustomSlider = __webpack_require__(72997);
;// CONCATENATED MODULE: ./src/components/pageBlocks/ProductSlider.tsx
function ProductSlider_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductSlider_templateObject() {
    var data = ProductSlider_taggedTemplateLiteral([
        "\n  position: relative;\n"
    ]);
    ProductSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductSlider_templateObject1() {
    var data = ProductSlider_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 600px;\n"
    ]);
    ProductSlider_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}









var SliderBlockWrapper = styled_components_browser_esm["default"].div(ProductSlider_templateObject());
var LoadingWrapper = styled_components_browser_esm["default"].div(ProductSlider_templateObject1());
function ProductSlider(param) {
    var collection = param.collection;
    var ref;
    var ref1;
    var ref2 = (0,generated/* useCollectionQuery */.aG9)({
        query: generated/* CollectionDocument */.Alj,
        skip: !(collection === null || collection === void 0 ? void 0 : collection.collectionId),
        variables: {
            id: (ref1 = collection === null || collection === void 0 ? void 0 : collection.collectionId) !== null && ref1 !== void 0 ? ref1 : "",
            first: 10
        }
    }), data = ref2.data, loading = ref2.loading;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {
                size: 32
            })
        });
    }
    if (!(data === null || data === void 0 ? void 0 : data.collection)) {
        return null;
    }
    var ref3 = data === null || data === void 0 ? void 0 : data.collection, name = ref3.name, products = ref3.products;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliderBlockWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider/* default */.Z, {
                    xl: 4,
                    lg: 3,
                    md: 2,
                    sm: 1.1,
                    title: /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                        title: name
                    }),
                    children: products === null || products === void 0 ? void 0 : (ref = products.edges) === null || ref === void 0 ? void 0 : ref.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products/* ProductCard */.Il, {
                            slug: product.node.slug
                        }, product.node.id);
                    }).filter(Boolean)
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./src/utils/numbers.ts
var numbers = __webpack_require__(60165);
;// CONCATENATED MODULE: ./src/api/datocms/types/Page.ts
var ProductListPattern;
(function(ProductListPattern) {
    ProductListPattern["Slider"] = "slider";
    ProductListPattern["Grid"] = "grid";
})(ProductListPattern || (ProductListPattern = {}));
var VideoListPattern;
(function(VideoListPattern) {
    VideoListPattern["Slider"] = "slider";
    VideoListPattern["Grid"] = "grid";
})(VideoListPattern || (VideoListPattern = {}));

;// CONCATENATED MODULE: ./src/components/pageBlocks/VideoList.tsx
function VideoList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function VideoList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            VideoList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function VideoList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function VideoList_templateObject() {
    var data = VideoList_taggedTemplateLiteral([
        "\n  height: 100%;\n  max-width: 800px;\n  margin: auto;\n"
    ]);
    VideoList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var VideoList_VideoWrapper = styled_components_browser_esm["default"].div(VideoList_templateObject());
function VideoList(param) {
    var title = param.title, description = param.description, videos = param.videos, videoPerLine = param.videoPerLine, displayPattern = param.displayPattern;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Container, {
            children: [
                !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                    title: title
                }),
                !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                    children: description
                }),
                displayPattern === VideoListPattern.Slider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider/* default */.Z, {
                    xl: 4,
                    lg: 4,
                    md: 2,
                    sm: 1.1,
                    title: title,
                    children: videos === null || videos === void 0 ? void 0 : videos.map(function(video) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoList_VideoWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, VideoList_objectSpread({}, video))
                        });
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: videos === null || videos === void 0 ? void 0 : videos.map(function(video) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            col: 12,
                            sm: (0,numbers/* smColSize */.IX)(videoPerLine),
                            md: (0,numbers/* mdColSize */.Pm)(videoPerLine),
                            lg: (0,numbers/* lgColSize */.S$)(videoPerLine),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoList_VideoWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, VideoList_objectSpread({}, video))
                            })
                        }, video.id);
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/collection/CollectionCard.tsx
function CollectionCard_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CollectionCard_templateObject() {
    var data = CollectionCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  padding: 16px;\n  color: ",
        ";\n  background: rgba(255, 255, 255, 0.8);\n  transition: background-color 0.15s;\n  border: 1px solid ",
        ";\n"
    ]);
    CollectionCard_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CollectionCard_templateObject1() {
    var data = CollectionCard_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  background-color: ",
        ";\n  margin-bottom: 24px;\n  ",
        ";\n\n  &:hover&:not(:disabled) {\n    ",
        " {\n      border: 1px solid ",
        ";\n    }\n  }\n\n  &:focus,\n  &:focus-visible {\n    outline: 3px solid ",
        ";\n  }\n"
    ]);
    CollectionCard_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function CollectionCard_templateObject2() {
    var data = CollectionCard_taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n"
    ]);
    CollectionCard_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function CollectionCard_templateObject3() {
    var data = CollectionCard_taggedTemplateLiteral([
        ""
    ]);
    CollectionCard_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function CollectionCard_templateObject4() {
    var data = CollectionCard_taggedTemplateLiteral([
        "\n  width: 100%;\n  height: auto;\n  position: relative;\n  &:after {\n    content: '';\n    display: block;\n    padding-bottom: calc(100% - 48px);\n  }\n"
    ]);
    CollectionCard_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}










var CollectionTitleBox = styled_components_browser_esm["default"].div(CollectionCard_templateObject(), (0,es/* palette */.DG)("secondary"), (0,es/* palette */.DG)("black20"));
var CardWrapper = styled_components_browser_esm["default"].div(CollectionCard_templateObject1(), (0,es/* palette */.DG)("white"), (0,shadowStyles/* default */.ZP)({
    color: "red",
    outlined: true,
    length: 8,
    showOnHover: true
}), CollectionTitleBox, (0,es/* palette */.DG)("red"), (0,es/* palette */.DG)("sky"));
var CollectionCard_LoadingWrapper = styled_components_browser_esm["default"].div(CollectionCard_templateObject2());
var CardLink = styled_components_browser_esm["default"].div(CollectionCard_templateObject3());
var ImageContainer = styled_components_browser_esm["default"].div(CollectionCard_templateObject4());
function CollectionCard(param) {
    var collectionId = param.collectionId, categorySlug = param.categorySlug;
    var ref = (0,generated/* useCollectionInfoQuery */.o2v)({
        query: generated/* CollectionInfoDocument */.cXu,
        variables: {
            id: collectionId !== null && collectionId !== void 0 ? collectionId : ""
        },
        skip: collectionId == null
    }), data = ref.data, loading = ref.loading;
    if (!(data === null || data === void 0 ? void 0 : data.collection)) {
        return null;
    }
    var ref1 = data === null || data === void 0 ? void 0 : data.collection, id = ref1.id, name = ref1.name, backgroundImage = ref1.backgroundImage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Link */.rU, {
        href: categorySlug ? (0,paths/* generatePath */.G)(paths/* paths.categories */.H.categories, categorySlug, "landingPage=true") : (0,paths/* generatePath */.G)(paths/* paths.productCollection */.H.productCollection, id),
        shallow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardLink, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                        children: (backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            src: backgroundImage === null || backgroundImage === void 0 ? void 0 : backgroundImage.url,
                            layout: "fill",
                            objectFit: "contain",
                            objectPosition: "center"
                        }) : null
                    }),
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCard_LoadingWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Loader */.aN, {
                            size: 32
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionTitleBox, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography.H6, {
                            children: name || "V\xf6rusafn"
                        })
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/CollectionList.tsx
function CollectionList_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function CollectionList_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            CollectionList_defineProperty(target, key, source[key]);
        });
    }
    return target;
}





function CollectionList(param) {
    var collections = param.collections;
    var count = collections === null || collections === void 0 ? void 0 : collections.length;
    var smSize = count > 1 ? 6 : 12;
    var inBetweenSize = count > 2 ? 4 : smSize;
    var mdSize = count > 3 ? 3 : inBetweenSize;
    (0,react.useEffect)(function() {
        if (true) {
            // eslint-disable-next-line array-callback-return
            collections.map(function(collection) {
                sessionStorage.removeItem("scrollPosition_".concat(collection.collectionId));
            });
        }
    }, [
        collections
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                children: collections === null || collections === void 0 ? void 0 : collections.map(function(collection) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        col: 12,
                        sm: smSize,
                        md: mdSize,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCard, CollectionList_objectSpread({}, collection))
                    }, collection.collectionId);
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/PageBanner.tsx
function PageBanner_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function PageBanner_templateObject() {
    var data = PageBanner_taggedTemplateLiteral([
        "\n    margin-top: 40px;\n  "
    ]);
    PageBanner_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function PageBanner_templateObject1() {
    var data = PageBanner_taggedTemplateLiteral([
        "\n    margin-top: 0px;\n  "
    ]);
    PageBanner_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function PageBanner_templateObject2() {
    var data = PageBanner_taggedTemplateLiteral([
        "\n  ",
        "\n  ",
        "\n"
    ]);
    PageBanner_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var BannerImage = (0,styled_components_browser_esm["default"])(dist.Container)(PageBanner_templateObject2(), dist.media.md(PageBanner_templateObject()), dist.media.lg(PageBanner_templateObject1()));
function PageBanner(param1) {
    var desktopImage = param1.desktopImage, link = param1.link;
    var ref, ref1, ref2;
    var BannerLink = function(param) {
        var children = param.children;
        return(// eslint-disable-next-line react/jsx-no-useless-fragment
        link ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: link,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        }));
    };
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerLink, {
        children: (desktopImage === null || desktopImage === void 0 ? void 0 : (ref = desktopImage.responsiveImage) === null || ref === void 0 ? void 0 : ref.src) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerImage, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Image */.Ee, {
                useImg: true,
                objectFit: "cover",
                src: desktopImage === null || desktopImage === void 0 ? void 0 : (ref1 = desktopImage.responsiveImage) === null || ref1 === void 0 ? void 0 : ref1.src,
                alt: (ref3 = desktopImage === null || desktopImage === void 0 ? void 0 : (ref2 = desktopImage.responsiveImage) === null || ref2 === void 0 ? void 0 : ref2.alt) !== null && ref3 !== void 0 ? ref3 : ""
            })
        }) : null
    });
};

// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 120 modules
var formik_esm = __webpack_require__(59433);
// EXTERNAL MODULE: ./src/api/sendgrid/index.ts
var sendgrid = __webpack_require__(28868);
// EXTERNAL MODULE: ./src/utils/email.ts
var email = __webpack_require__(78229);
// EXTERNAL MODULE: ./src/utils/validation.ts
var validation = __webpack_require__(37424);
// EXTERNAL MODULE: ./src/components/form/FileInput.tsx
var FileInput = __webpack_require__(80501);
;// CONCATENATED MODULE: ./src/components/pageBlocks/ContactForm.tsx
function ContactForm_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ContactForm_templateObject() {
    var data = ContactForm_taggedTemplateLiteral([
        "\n  max-width: 800px;\n  margin: auto;\n"
    ]);
    ContactForm_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ContactForm_templateObject1() {
    var data = ContactForm_taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"
    ]);
    ContactForm_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ContactForm_templateObject2() {
    var data = ContactForm_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  text-align: center;\n"
    ]);
    ContactForm_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ContactForm_templateObject3() {
    var data = ContactForm_taggedTemplateLiteral([
        "\n  margin-top: 16px;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    ContactForm_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}














var ContactFormWrapper = styled_components_browser_esm["default"].div(ContactForm_templateObject());
var ButtonWrapper = styled_components_browser_esm["default"].div(ContactForm_templateObject1());
var Status = styled_components_browser_esm["default"].div(ContactForm_templateObject2());
var Error = styled_components_browser_esm["default"].div(ContactForm_templateObject3(), (0,es/* palette */.DG)("red"));
var Form = function(param) {
    var handleSubmit = param.handleSubmit, isSubmitting = param.isSubmitting, status = param.status;
    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("form", {
        onSubmit: handleSubmit,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(dist.Row, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        col: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                            label: "Nafn",
                            name: "name"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        col: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                            label: "Netfang",
                            name: "email"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        col: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.ZP, {
                            label: "Skilabo\xf0",
                            name: "message",
                            type: "textarea"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                        col: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FileInput/* default */.Z, {
                            label: "Vi\xf0hengi",
                            name: "file",
                            type: "file",
                            withGutter: true
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons/* Button */.zx, {
                        type: "submit",
                        disabled: isSubmitting,
                        children: "Senda skilabo\xf0"
                    }),
                    !!(status === null || status === void 0 ? void 0 : status.success) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Status, {
                        children: status.success
                    }),
                    !!(status === null || status === void 0 ? void 0 : status.error) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Error, {
                        children: status.error
                    })
                ]
            })
        ]
    });
};
var ContactFormik = (0,formik_esm/* withFormik */.j0)({
    mapPropsToValues: function() {
        return {
            name: "",
            email: "",
            message: "",
            file: undefined
        };
    },
    validate: function(param) {
        var name = param.name, email = param.email, message = param.message;
        var errors = {};
        if (!name) {
            errors.name = "H\xe9r vantar nafn";
        }
        if (!message) {
            errors.message = "H\xe9r vantar skilabo\xf0";
        }
        if (!email) {
            errors.email = "H\xe9r vantar netfang";
        } else if (!(0,validation/* validateEmail */.o)(email)) {
            errors.email = "Netfang ekki \xe1 r\xe9ttu formi";
        }
        return errors;
    },
    handleSubmit: function(values, param) {
        var subject = param.props.subject, setSubmitting = param.setSubmitting, setStatus = param.setStatus;
        var message = (0,email/* makeContactFormMessage */._s)(values);
        (0,sendgrid/* sendEmail */.C)(values.name, subject, message, values.file).then(function(res) {
            if (res.status !== 200) {
                setSubmitting(false);
                setStatus({
                    error: "Eitthva\xf0 f\xf3r \xfarskei\xf0is. Vinsamlegast reyndu aftur."
                });
            } else {
                setStatus({
                    success: "Skilabo\xf0 m\xf3ttekin"
                });
            }
        });
    },
    displayName: "ContactForm"
})(Form);
function ContactForm(param) {
    var title = param.title, description = param.description, subject = param.subject;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContactFormWrapper, {
            children: [
                !!title && /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockTitle */.bi, {
                    title: title
                }),
                !!description && /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* PLarge */.cG, {
                    withGutter: true,
                    children: description
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContactFormik, {
                    subject: subject !== null && subject !== void 0 ? subject : ""
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
;// CONCATENATED MODULE: ./src/components/pageBlocks/HtmlBlock.tsx





function HtmlBlock(param) {
    var html = param.html;
    if (!html) {
        return null;
    }
    var parsedHtml = (0,html_react_parser/* default */.ZP)(html);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layout/* BlockWrapper */.qm, {
        children: !!parsedHtml && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: parsedHtml
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-use/esm/useWindowSize.js + 3 modules
var useWindowSize = __webpack_require__(72977);
;// CONCATENATED MODULE: ./src/components/pageBlocks/BannerCollection.tsx
function BannerCollection_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BannerCollection_templateObject() {
    var data = BannerCollection_taggedTemplateLiteral([
        "\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  .iframe {\n    width: 98%;\n    height: calc(100vh - 100px);\n  }\n  .mobile-iframe {\n    width: 92%;\n    height: calc(100vh - 240px);\n  }\n  .mobile-close {\n    position: absolute;\n    right: 20px;\n  }\n  .desktop-close {\n    position: absolute;\n    right: 90px;\n  }\n"
    ]);
    BannerCollection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function BannerCollection_templateObject1() {
    var data = BannerCollection_taggedTemplateLiteral([
        "\n  position: absolute;\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  line-height: 24px;\n  text-shadow: rgb(0 0 0) 0px 0px 3px;\n  text-transform: uppercase;\n  float: right;\n  margin-top: 12px;\n  background: transparent;\n  border: 0px;\n  color: ",
        ";\n"
    ]);
    BannerCollection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function BannerCollection_templateObject2() {
    var data = BannerCollection_taggedTemplateLiteral([
        "\n  .desktop {\n    margin: 10px 75px;\n  }\n  .mobile {\n    margin: 0 25px;\n  }\n  .banner-wrapper {\n    margin-top: 50px;\n    border: 1px solid transparent;\n    display: flex;\n    justify-content: center;\n    :hover {\n      border: 1px solid red;\n    }\n  }\n  .banner {\n    background-color: rgb(254, 254, 254);\n    border: 1px solid rgb(209, 209, 209);\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 20px 0;\n    transition: transform 0.5s ease 0s;\n    :hover {\n      transform: translateY(-8px) translatex(8px);\n    }\n    cursor: pointer;\n  }\n  .title {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  .img {\n    border: none !important;\n    height: 300px;\n    object-fit: contain;\n  }\n  .mobile-img {\n    border: none !important;\n    height: 350px;\n    object-fit: contain;\n  }\n"
    ]);
    BannerCollection_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

/* eslint-disable @next/next/no-img-element */ 




var ViewBanner = styled_components_browser_esm["default"].div(BannerCollection_templateObject());
var CloseButton = styled_components_browser_esm["default"].button(BannerCollection_templateObject1(), (0,es/* palette */.DG)("red"));
var BannerContainer = styled_components_browser_esm["default"].div(BannerCollection_templateObject2());
function BannerCollection_Banner(param) {
    var image = param.image, link = param.link, handleImageClick = param.handleImageClick, title = param.title, isMobile = param.isMobile;
    if (image && link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "banner-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "banner",
                onClick: function() {
                    return handleImageClick(link);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: image,
                            className: isMobile ? "mobile-img" : "img",
                            alt: ""
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}
function BannerCollection(param) {
    var brochures = param.brochures;
    var width = (0,useWindowSize/* default */.Z)().width;
    var bannerRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(3), columns = ref3[0], setColumns = ref3[1];
    var ref1 = (0,react.useState)(false), isMobile = ref1[0], setIsMobile = ref1[1];
    var ref2 = (0,react.useState)(), selected = ref2[0], setSelected = ref2[1];
    var handleImageClick = function(link) {
        var decoded = link.replace("amp;", "");
        setSelected(decoded);
    };
    var handleClose = function() {
        setSelected(undefined);
    };
    var handleKeypress = function(event) {
        if (event.code === "Escape" && selected) {
            setSelected(undefined);
        }
    };
    // eslint-disable-next-line consistent-return
    (0,react.useEffect)(function() {
        if (width > 1024) {
            return setColumns(3);
        }
        if (width <= 1150 && width > 900) {
            return setColumns(4);
        }
        if (width <= 900 && width >= 768) {
            if (isMobile) {
                setIsMobile(false);
            }
            return setColumns(6);
        }
        if (width < 768) {
            setIsMobile(true);
            return setColumns(12);
        }
    }, [
        isMobile,
        width
    ]);
    (0,react.useEffect)(function() {
        if (selected && isMobile) {
            var ref;
            (ref = bannerRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView({
                block: "center"
            });
        }
    }, [
        selected,
        isMobile
    ]);
    (0,react.useEffect)(function() {
        document.addEventListener("mousedown", function(event) {
            var ref;
            if (!((ref = bannerRef.current) === null || ref === void 0 ? void 0 : ref.contains(event.target))) {
                setSelected(undefined);
            }
        });
        document.addEventListener("keydown", handleKeypress);
        return function() {
            document.removeEventListener("keydown", handleKeypress);
        };
    });
    if (!brochures || !brochures.length) {
        return null;
    }
    var banners = brochures === null || brochures === void 0 ? void 0 : brochures.filter(function(entry) {
        return entry != null;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ViewBanner, {
                    ref: bannerRef,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseButton, {
                            type: "button",
                            onClick: handleClose,
                            className: isMobile ? "mobile-close" : "desktop-close",
                            children: "close"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            className: isMobile ? "mobile-iframe" : "iframe",
                            title: selected,
                            sandbox: "allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin allow-popups allow-modals allow-popups-to-escape-sandbox allow-forms",
                            allow: "clipboard-write",
                            allowFullScreen: true,
                            src: selected
                        })
                    ]
                })
            }),
            !selected && /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: isMobile ? "mobile" : "desktop",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                            children: banners.map(function(banner) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(dist.Col, {
                                    col: columns,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerCollection_Banner, {
                                        image: (ref = banner.image) === null || ref === void 0 ? void 0 : ref.url,
                                        link: banner.link,
                                        handleImageClick: handleImageClick,
                                        title: banner.title,
                                        isMobile: isMobile
                                    }, banner.id)
                                });
                            })
                        })
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/typography/Headings.tsx
var Headings = __webpack_require__(94540);
;// CONCATENATED MODULE: ./src/components/pageBlocks/ProductsList.tsx
function ProductsList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function ProductsList_templateObject() {
    var data = ProductsList_taggedTemplateLiteral([
        "\n  .slider-title {\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 1.5;\n  }\n  .slider-wrapper {\n    margin-left: 10px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    ProductsList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProductsList_templateObject1() {
    var data = ProductsList_taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  margin-top: 10px;\n  H3 {\n    margin-left: 20px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    ProductsList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var ProductListContainer = styled_components_browser_esm["default"].div(ProductsList_templateObject());
var ProductsBlock = styled_components_browser_esm["default"].div(ProductsList_templateObject1());
function ProductsList(props) {
    var products = props.products, displayPattern = props.displayPattern, title = props.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListContainer, {
        children: displayPattern === ProductListPattern.Slider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider/* default */.Z, {
            xl: 3,
            lg: 3,
            md: 2,
            sm: 1.1,
            title: title,
            children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products/* ProductCard */.Il, {
                    slug: product.product
                }, product.id);
            }).filter(Boolean)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductsBlock, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings.H3, {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            sm: 6,
                            xs: 12,
                            md: 4,
                            lg: 4,
                            xl: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products/* ProductCard */.Il, {
                                slug: product.product
                            }, product.id)
                        });
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/CategoryProductList.tsx
function CategoryProductList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CategoryProductList_templateObject() {
    var data = CategoryProductList_taggedTemplateLiteral([
        "\n  .slider-title {\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 1.5;\n  }\n  .slider-wrapper {\n    margin-left: 10px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    CategoryProductList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CategoryProductList_templateObject1() {
    var data = CategoryProductList_taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  margin-top: 10px;\n  H3 {\n    margin-left: 20px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    CategoryProductList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var CategoryProductList_ProductListContainer = styled_components_browser_esm["default"].div(CategoryProductList_templateObject());
var CategoryProductList_ProductsBlock = styled_components_browser_esm["default"].div(CategoryProductList_templateObject1());
function CategoryProductList_ProductsList(props) {
    var productList = props.productList, displayPattern = props.displayPattern, title = props.title;
    var products = JSON.parse(productList);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryProductList_ProductListContainer, {
        children: displayPattern === ProductListPattern.Slider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider/* default */.Z, {
            xl: 3,
            lg: 3,
            md: 2,
            sm: 1.1,
            title: title,
            children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products/* ProductCard */.Il, {
                    slug: product.slug
                }, product.id);
            }).filter(Boolean)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategoryProductList_ProductsBlock, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings.H3, {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            sm: 6,
                            xs: 12,
                            md: 4,
                            lg: 4,
                            xl: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products/* ProductCard */.Il, {
                                slug: product.slug
                            }, product.id)
                        });
                    })
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/CollectionProductList.tsx
function CollectionProductList_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function CollectionProductList_templateObject() {
    var data = CollectionProductList_taggedTemplateLiteral([
        "\n  .slider-title {\n    font-weight: 600;\n    font-size: 30px;\n    line-height: 1.5;\n  }\n  .slider-wrapper {\n    margin-left: 10px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    CollectionProductList_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function CollectionProductList_templateObject1() {
    var data = CollectionProductList_taggedTemplateLiteral([
        "\n  margin-left: 10px;\n  margin-top: 10px;\n  H3 {\n    margin-left: 20px;\n    margin-bottom: 20px;\n  }\n"
    ]);
    CollectionProductList_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var CollectionProductList_ProductListContainer = styled_components_browser_esm["default"].div(CollectionProductList_templateObject());
var CollectionProductList_ProductsBlock = styled_components_browser_esm["default"].div(CollectionProductList_templateObject1());
function CollectionProductList_ProductsList(props) {
    var productList = props.productList, displayPattern = props.displayPattern, title = props.title;
    var products = JSON.parse(productList);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionProductList_ProductListContainer, {
        children: displayPattern === ProductListPattern.Slider ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSlider/* default */.Z, {
            xl: 4,
            lg: 4,
            md: 2,
            sm: 1.1,
            title: title,
            children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products/* ProductCard */.Il, {
                    slug: product.slug
                }, product.id);
            }).filter(Boolean)
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionProductList_ProductsBlock, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Headings.H3, {
                        children: title
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Row, {
                    children: products === null || products === void 0 ? void 0 : products.map(function(product) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Col, {
                            sm: 6,
                            xs: 12,
                            md: 4,
                            lg: 3,
                            xl: 3,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_products/* ProductCard */.Il, {
                                slug: product.slug
                            }, product.id)
                        });
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/components/pageBlocks/BannerSlider.tsx
function BannerSlider_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function BannerSlider_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            BannerSlider_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function BannerSlider_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function BannerSlider_templateObject() {
    var data = BannerSlider_taggedTemplateLiteral([
        "\n  padding: 20px;\n\n  .slick-arrow::before {\n    color: rgb(239, 63, 87);\n    opacity: 1;\n  }\n  .slick-dots li button::before {\n    color: rgb(239, 63, 87);\n    font-size: 10px;\n  }\n\n  .slick-slider div {\n    padding: 0px;\n  }\n\n  @media screen and (max-width: 768px) {\n    padding: 5px;\n\n    .slick-arrow {\n      display: none !important;\n    }\n    .slick-slider,\n    .slick-list,\n    .slick-active,\n    .slick-current {\n      padding: 0px !important;\n    }\n\n    .slick-slider div {\n      padding: 0px;\n    }\n  }\n"
    ]);
    BannerSlider_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable @next/next/no-img-element */ 




var BannerSlider_BannerContainer = styled_components_browser_esm["default"].div(BannerSlider_templateObject());
function BannerSlider(param) {
    var banner = param.banner, slideSpeed = param.slideSpeed;
    if (!banner || !banner.length) {
        return null;
    }
    var settings = {
        dots: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: slideSpeed ? slideSpeed * 1000 : 5000,
        cssEase: "linear",
        swipeToSlide: true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerSlider_BannerContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, BannerSlider_objectSpread({}, settings, {
                children: banner.map(function(item) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Banner, {
                        image: item === null || item === void 0 ? void 0 : item.image,
                        link: item.link,
                        title: item === null || item === void 0 ? void 0 : item.title,
                        linkLabel: item === null || item === void 0 ? void 0 : item.linkLabel,
                        description: item === null || item === void 0 ? void 0 : item.description,
                        heightMob: item === null || item === void 0 ? void 0 : item.heightMob,
                        __typename: "BannerRecord",
                        id: undefined
                    }, item.id);
                })
            }))
        })
    });
};

;// CONCATENATED MODULE: ./src/components/pageBlocks/VideoCover.tsx
function VideoCover_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function VideoCover_templateObject() {
    var data = VideoCover_taggedTemplateLiteral([
        "\n  margin: 20px auto 0px auto;\n  padding: 0px;\n  background: #ef3f57;\n  width: ",
        ";\n  height: ",
        ";\n  max-width: 100%;\n  .desktop {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n  }\n  .mobile {\n    display: none;\n    max-width: 100%;\n    height: auto;\n  }\n\n  @media screen and (max-width: 768px) {\n    width: 100%;\n    height: fit-content;\n    .mobile {\n      display: block;\n    }\n    .desktop {\n      display: none;\n    }\n  }\n"
    ]);
    VideoCover_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* eslint-disable @next/next/no-img-element */ 


var VideoContainer = styled_components_browser_esm["default"].div(VideoCover_templateObject(), function(props) {
    return props.width ? "".concat(props.width, "px") : "1400px";
}, function(props) {
    return props.height ? "".concat(props.height, "px") : "600px";
});
var VideoCover = function(props) {
    var width = props.width, height = props.height;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist.Container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(VideoContainer, {
            width: width,
            height: height,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    muted: true,
                    autoPlay: true,
                    loop: true,
                    playsInline: true,
                    className: "desktop",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: props.desktop.video.mp4Url,
                        type: "video/mp4"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                    muted: true,
                    autoPlay: true,
                    loop: true,
                    playsInline: true,
                    className: "mobile",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                        src: props.mobile.video.mp4Url,
                        type: "video/mp4"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var pageBlocks_VideoCover = (VideoCover);

;// CONCATENATED MODULE: ./src/components/pageBlocks/index.tsx



























;// CONCATENATED MODULE: ./src/components/content/content-map.tsx

var contentMap = {
    TextBlockRecord: TextBlock,
    ImageBlockRecord: ImageBlock,
    EmployeeListRecord: EmployeeList,
    TextImageBlockRecord: TextImageBlock,
    IconBlockRecord: IconBlock,
    BulletListRecord: BulletList,
    ValueListRecord: ValueList,
    SupplierListRecord: SupplierList,
    AccordionListRecord: AccordionList,
    BannerRecord: Banner,
    CtaBlockRecord: CtaBlock,
    MailchimpFormRecord: MailChimpForm,
    ProductSliderRecord: ProductSlider,
    HeroBannerRecord: HeroBanner,
    VideoListRecord: VideoList,
    CollectionListRecord: CollectionList,
    PageBannerRecord: PageBanner,
    ContactFormRecord: ContactForm,
    HtmlBlockRecord: HtmlBlock,
    VideoBlockRecord: VideoBlock,
    BannerCollectionRecord: BannerCollection,
    BannerSliderRecord: BannerSlider,
    ProductsListRecord: ProductsList,
    CategoryProductListRecord: CategoryProductList_ProductsList,
    CollectionProductListRecord: CollectionProductList_ProductsList,
    VideoCoverRecord: pageBlocks_VideoCover
};

;// CONCATENATED MODULE: ./src/components/content/DatocmsContent.tsx
function DatocmsContent_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DatocmsContent_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DatocmsContent_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function DatocmsContent_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function DatocmsContent_templateObject() {
    var data = DatocmsContent_taggedTemplateLiteral([
        "\n  transition: width 0.2s ease-in-out;\n  padding: 0px;\n  padding-top: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  a {\n    margin: 0px;\n    padding: 0px;\n  }\n  .remixicon-icon {\n    width: ",
        ";\n    visibility: ",
        ";\n    margin-right: ",
        ";\n    transition: width 0.2s ease-in-out;\n  }\n  &:hover {\n    color: ",
        ";\n    .remixicon-icon {\n      margin-right: 6px;\n      width: 20px;\n      visibility: visible;\n    }\n  }\n"
    ]);
    DatocmsContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function DatocmsContent_templateObject1() {
    var data = DatocmsContent_taggedTemplateLiteral([
        "\n  display: flex;\n  padding: 10px 20px;\n  max-width: 1810px;\n  margin: auto;\n  position: relative;\n  @media screen and (max-width: ",
        ") {\n    padding: 0px;\n  }\n"
    ]);
    DatocmsContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function DatocmsContent_templateObject2() {
    var data = DatocmsContent_taggedTemplateLiteral([
        "\n  position: ",
        ";\n\n  top: ",
        ";\n\n  padding-top: 20px;\n  width: 15%;\n  height: calc(100vh - 200px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  ",
        " {\n    text-transform: lowercase;\n    &::first-letter {\n      text-transform: capitalize;\n    }\n    &:hover {\n      color: ",
        ";\n    }\n  }\n  @media screen and (max-width: ",
        ") {\n    display: none;\n  }\n  @media screen and (max-height: 700px) {\n    overflow-x: hidden;\n    ",
        "\n  }\n"
    ]);
    DatocmsContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function DatocmsContent_templateObject3() {
    var data = DatocmsContent_taggedTemplateLiteral([
        "\n  width: 85%;\n  margin-left: auto;\n  @media screen and (max-width: ",
        ") {\n    width: 100%;\n  }\n"
    ]);
    DatocmsContent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}













var Category = styled_components_browser_esm["default"].div(DatocmsContent_templateObject(), function(param) {
    var selected = param.selected;
    return selected ? "20px" : "0px";
}, function(param) {
    var selected = param.selected;
    return selected ? "visible" : "hidden";
}, function(param) {
    var selected = param.selected;
    return selected ? "6px" : "0px";
}, themes/* theme.palette.red */.r.palette.red);
var PageSection = styled_components_browser_esm["default"].div(DatocmsContent_templateObject1(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
var CategorySidebar = styled_components_browser_esm["default"].div(DatocmsContent_templateObject2(), function(props) {
    return props.scrollValue >= props.pageHeight - props.sidebarHeight ? "absolute" : "fixed";
}, function(props) {
    return props.scrollValue >= props.pageHeight - props.sidebarHeight ? "".concat(props.pageHeight - props.sidebarHeight, "px") : "inherit";
}, typography/* Title7 */.Mz, themes/* theme.palette.red */.r.palette.red, themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD, (0,scrollStyle/* default */.Z)({
    color: "red"
}));
var CmsContent = styled_components_browser_esm["default"].div(DatocmsContent_templateObject3(), themes/* theme.screenSize.sizeMD */.r.screenSize.sizeMD);
function DatocmsContent(param) {
    var content = param.content;
    var ref6, ref1;
    var ref2 = (0,react.useState)(), categories = ref2[0], setCategories = ref2[1];
    var ref3 = (0,react.useState)(), categoryMap = ref3[0], setCategoryMap = ref3[1];
    var ref4 = (0,react.useState)(0), scrollValue = ref4[0], setScrollValue = ref4[1];
    var sidebarRef = (0,react.useRef)(null);
    var pageRef = (0,react.useRef)(null);
    var pathname = (0,router.useRouter)().pathname;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var ref5 = (0,generated/* useNavigationCategoriesQuery */.nFH)(), categoriesData = ref5.data;
    var navigationInfo = (0,PageContext/* usePageContext */.lO)().navigationInfo;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    var handleScroll = function() {
        setScrollValue(window.scrollY);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        var catArr = navigationInfo === null || navigationInfo === void 0 ? void 0 : (ref = navigationInfo.navBlocks) === null || ref === void 0 ? void 0 : ref.map(// eslint-disable-next-line no-return-assign
        function(block) {
            return block.slug;
        });
        setCategories(catArr);
    }, [
        navigationInfo
    ]);
    (0,react.useEffect)(function() {
        var ref, ref7;
        var categories_map = {};
        categoriesData === null || categoriesData === void 0 ? void 0 : (ref = categoriesData.categories) === null || ref === void 0 ? void 0 : (ref7 = ref.edges) === null || ref7 === void 0 ? void 0 : ref7.forEach(function(cat) {
            var node = cat.node;
            categories_map[node.slug] = node;
        });
        setCategoryMap(categories_map);
    }, [
        categoriesData
    ]);
    if (!content) {
        return null;
    }
    var entries = content.filter(function(entry) {
        return entry != null;
    });
    var isHomePage = pathname === "/";
    return isHomePage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(PageSection, {
        ref: pageRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CategorySidebar, {
                pageHeight: (pageRef === null || pageRef === void 0 ? void 0 : (ref6 = pageRef.current) === null || ref6 === void 0 ? void 0 : ref6.offsetHeight) || 0,
                sidebarHeight: (sidebarRef === null || sidebarRef === void 0 ? void 0 : (ref1 = sidebarRef.current) === null || ref1 === void 0 ? void 0 : ref1.offsetHeight) || 0,
                scrollValue: scrollValue,
                ref: sidebarRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Link */.rU, {
                            href: paths/* paths.categories */.H.categories,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                bottom: 5,
                                top: 10,
                                children: "Allir v\xf6ruflokkar"
                            })
                        })
                    }),
                    categories && categoryMap && categories.map(function(cat) {
                        var ref, ref8, ref9;
                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Category, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((ArrowRightLineIcon_default()), {
                                    color: themes/* theme.palette.red */.r.palette.red
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Link */.rU, {
                                    href: (0,paths/* generatePath */.G)(paths/* paths.categories */.H.categories, categoryMap && ((ref = categoryMap[cat]) === null || ref === void 0 ? void 0 : ref.slug), "landingPage=true"),
                                    shallow: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(typography/* Title7 */.Mz, {
                                        children: categoryMap && ((ref8 = categoryMap[cat]) === null || ref8 === void 0 ? void 0 : ref8.name)
                                    })
                                })
                            ]
                        }, categoryMap && ((ref9 = categoryMap[cat]) === null || ref9 === void 0 ? void 0 : ref9.id));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CmsContent, {
                children: entries.map(function(entry) {
                    var Component = contentMap[entry.__typename];
                    return Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, DatocmsContent_objectSpread({}, entry), entry.id) : null;
                })
            })
        ]
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: entries.map(function(entry) {
            var Component = contentMap[entry.__typename];
            return Component ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, DatocmsContent_objectSpread({}, entry), entry.id) : null;
        })
    });
}


/***/ }),

/***/ 80501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59433);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);
/* harmony import */ var _buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(31494);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92469);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






var Input = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].input(_templateObject());
var FieldWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__["default"].div(_templateObject1());
function FormikFileInput(props) {
    var ref;
    var ref1 = (0,formik__WEBPACK_IMPORTED_MODULE_1__/* .useFormikContext */ .u6)(), values = ref1.values, setFieldValue = ref1.setFieldValue, getFieldMeta = ref1.getFieldMeta;
    var fileRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var meta = getFieldMeta("file");
    var showError = !!(meta.error && meta.touched);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .InputWrapper */ .SP, {
        withGutter: props.withGutter,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .InputLabel */ .AZ, {
                htmlFor: props.id,
                disabled: props.disabled,
                children: props.label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Input__WEBPACK_IMPORTED_MODULE_4__/* .InputSleeve */ .bx, {
                errorMsg: meta.error,
                showError: showError,
                info: props.info,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Input, {
                        name: "file",
                        type: "file",
                        accept: "application/pdf",
                        onChange: function(event) {
                            if (!(event === null || event === void 0 ? void 0 : event.currentTarget.files) || !(event === null || event === void 0 ? void 0 : event.currentTarget.files[0])) {
                                return;
                            }
                            setFieldValue("file", event.currentTarget.files[0]);
                        },
                        ref: fileRef
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(FieldWrapper, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_buttons__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, {
                                outlined: true,
                                onClick: function() {
                                    return fileRef.current && fileRef.current.click();
                                },
                                style: {
                                    marginRight: "16px"
                                },
                                type: "button",
                                children: "Velja skr\xe1"
                            }),
                            (ref = values.file) === null || ref === void 0 ? void 0 : ref.name
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormikFileInput);


/***/ }),

/***/ 78229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "xb": function() { return /* binding */ makeEmploymentMessage; },
/* harmony export */   "_s": function() { return /* binding */ makeContactFormMessage; }
/* harmony export */ });
/* unused harmony export makeTransactionMessage */
function makeTransactionMessage(param) {
    var name = param.name, ssn = param.ssn, phone = param.phone, email = param.email, address = param.address, city = param.city, postalCode = param.postalCode, poBox = param.poBox, website = param.website, cashierEmail = param.cashierEmail, cashierName = param.cashierName, cashierPhone = param.cashierPhone, employees = param.employees, adminEmail = param.adminEmail, amount = param.amount, paymentMethod = param.paymentMethod, contacts = param.contacts, auditors = param.auditors, owners = param.owners;
    return '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n  <html lang="is">\n  <head>\n    <meta charset="utf-8">\n    <title>Ums\xf3kn um reikningsvi\xf0skipti</title>\n    <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />\n  </head>\n\n  <body>\n    <div>\n      <h3>N\xfd ums\xf3kn um reikningsvi\xf0skipti fr\xe1 '.concat(name, "</h3>\n      <p>Kennitala: ").concat(ssn, "</p>\n      <p>S\xedmi: ").concat(phone, "</p>\n      <p>Netfang: ").concat(email, "</p>\n      <p>Heimilisfang: ").concat(address, ", ").concat(postalCode, " ").concat(city, "</p>\n      ").concat(poBox ? "<p>P\xf3stbox: ".concat(poBox, "</p>") : "", "\n      ").concat(website ? "<p>Vefs\xed\xf0a: ".concat(website, "</p>") : "", "\n      <p>Fj\xf6ldi starfsmanna: ").concat(employees, "</p>\n      <p>Nafn gjaldkera: ").concat(cashierName, "</p>\n      <p>Netfang gjaldkera: ").concat(cashierEmail, "</p>\n      <p>S\xedmi gjaldkera: ").concat(cashierPhone, "</p>\n      <h4>Tengili\xf0ir</h4>\n      ").concat(contacts.map(function(contact) {
        return "<div>\n              <p>Nafn tengili\xf0s: ".concat(contact.name, "</p>\n              ").concat(contact.title ? "<p>Starfstitill: ".concat(contact.title, "</p>") : "", "\n              ").concat(contact.phone ? "<p>S\xedmi: ".concat(contact.phone, "</p>") : "", "\n              <p>Netfang tengili\xf0s: ").concat(contact.email, "</p>\n              ").concat(contact.job ? "<p>Starfsheiti: ".concat(contact.job, "</p>") : "", "\n          </div>");
    }), "\n      <h4>\xdattektara\xf0ilar</h4>\n      ").concat(auditors.map(function(auditor) {
        return "<div>\n            <p>Nafn \xfattektara\xf0ila: ".concat(auditor.name, "</p>\n            <p>Kennitala \xfattektara\xf0ila: ").concat(auditor.ssn, "</p>\n          </div>");
    }), "\n      <h4>Eigendur</h4>\n      ").concat(owners.map(function(owner) {
        return "<div>\n            <p>Nafn eiganda: ".concat(owner.name, "</p>\n            <p>Kennitala eiganda: ").concat(owner.ssn, "</p>\n          </div>");
    }), "\n      <p>A\xf0gangur a\xf0 vefverslun RV sendist \xe1 netfangi\xf0: ").concat(adminEmail, "</p>\n      <p>\xc1\xe6tlu\xf0 vi\xf0skipti \xe1 m\xe1nu\xf0i kr: ").concat(amount, "</p>\n      <p>Grei\xf0sluh\xe1ttur: ").concat(paymentMethod, "</p>\n    </div>\n  </body>\n  </html>");
}
function makeEmploymentMessage(param) {
    var name = param.name, email = param.email, ssn = param.ssn, address = param.address, postalCode = param.postalCode, city = param.city, phone = param.phone, education = param.education, family = param.family, hobbies = param.hobbies, hours = param.hours, job = param.job, references = param.references, smoker = param.smoker, start = param.start, time = param.time, type = param.type;
    return '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n  <html lang="is">\n  <head>\n    <meta charset="utf-8">\n    <title>Ums\xf3kn um starf</title>\n    <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />\n  </head>\n\n  <body>\n    <div>\n      <h3>N\xfd ums\xf3kn um starf fr\xe1 '.concat(name, "</h3>\n      <p>Kennitala: ").concat(ssn, "</p>\n      <p>S\xedmi: ").concat(phone, "</p>\n      <p>Netfang: ").concat(email, "</p>\n      <p>Heimilisfang: ").concat(address, ", ").concat(postalCode, " ").concat(city, "</p>\n      <p>S\xf3tt um: ").concat(type, "</p>\n      <p>N\xfaverandi starf: ").concat(job, "</p>\n      <p>Fj\xf6lskylduhagir: ").concat(family, "</p>\n      <p>\xc1hugam\xe1l: ").concat(hobbies, '</p>\n      <p>Menntun:</p>\n      <p style="white-space: pre-wrap;">').concat(education, '</p>\n      <p>Me\xf0m\xe6li:</p>\n      <p style="white-space: pre-wrap;">').concat(references, "</p>\n      <p>Vinnut\xedmi fr\xe1/til: ").concat(hours, "</p>\n      <p>Reykir: ").concat(smoker, "</p>\n      <p>Getur byrja\xf0: ").concat(start, "</p>\n      <p>").concat(time, "</p>\n    </div>\n  </body>\n  </html>");
}
function makeContactFormMessage(param) {
    var name = param.name, email = param.email, message = param.message;
    return '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">\n  <html lang="is">\n  <head>\n    <meta charset="utf-8">\n    <title>N\xfd skilabo\xf0 fr\xe1 rv.is</title>\n    <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />\n  </head>\n\n  <body>\n    <div>\n      <h3>N\xfd skilabo\xf0 fr\xe1 '.concat(name, "</h3>\n      <p>Netfang: ").concat(email, '</p>\n      <p>Skilabo\xf0:</p>\n      <p style="white-space: pre-wrap;">').concat(message, "</p>\n    </div>\n  </body>\n  </html>");
}


/***/ })

}]);